import { Link } from "react-router-dom";
import NavButton from "./SubNav/NavButton";
import LiItemWeb from "./SubNav/LiItemWeb";
import HamburgerMenu from "./SubNav/HamburgerMenu";
import LoginIcon from "../Icons/LoginIcon";
import SupportIcon from "../Icons/SupportIcon";

function Navbar() {
    return (
        <div className="bg-white h-12 md:h-20 shadow flex flex-row-reverse items-center justify-around z-40">
            <Link to="/">
                <img src="/image/Logo.png" className="md:w-14 w-10 p-1" />
            </Link>
            <ul className="flex-row-reverse items-center justify-center mb-10 md:mb-0 md:flex md:space-x-6 md:space-y-0 md:block hidden">
                <LiItemWeb text="دانلود اپلیکیشن" link="/#downloadApp" />
                <LiItemWeb text="ورود به نسخه وب" link="/#linktoMessenger" />
                <LiItemWeb text="تماس با ما" link="/#callwithUs" />
            </ul>
            <div className="hidden space-x-2 md:inline-block">
                <div className="flex flex-row items-center">
                    {/* <NavButton text="support" title="پشتیبانی" w="w-12" /> */}
                    {/* <NavButton text="Login" title="ورود" w="w-16" /> */}
                    <Link to="/login" className="flex flex-row-reverse items-center bg-primary-500 py-2 px-4 rounded-md text-white mr-4">
                        <LoginIcon />
                        <p className="mr-1">ورود</p>
                    </Link>
                    <Link to="/support" className="flex flex-row-reverse items-center border border-slate-300 py-2 px-3 rounded-md text-primary-500">
                        <SupportIcon />
                        <p className="mr-1">پشتیبانی</p>
                    </Link>
                </div>
            </div>

            <HamburgerMenu />
        </div>
    );
}
export default Navbar;